// extracted by mini-css-extract-plugin
module.exports = {"section":"styles-module--section--2dcrW","nav":"styles-module--nav--9Jg-T","visible":"styles-module--visible---j36A"};